import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API, environment } from '@core/envs';
import { Observable } from 'rxjs';
import { RecallHistory } from 'libs/core/src/interfaces/from-history/models';
import { IResponseModel } from '@core/interface';


const BASE_URL = environment.getRoute(API.owners);

@Injectable({
  providedIn: 'root'
})
export class RecallService {
  constructor(private http: HttpClient) { }

  getRecall(vin: string, status: string, country: string): Observable<IResponseModel<RecallHistory[]>> {
    const url = `${BASE_URL}/recalls/v2?status=${status}&selectedType=C,E,S`;
    const headers = new HttpHeaders({
      country
    });
    return this.http.post<IResponseModel<RecallHistory[]>>(url, { vin }, { headers });
  }

  setNewLastPrintDate(vin: string): Observable<void> {
    const url = `${BASE_URL}/recalls/${vin}/print-date`;
    return this.http.put<void>(url, {}, { headers: { Anonymous: '' } });
  }

  getRecallCertificate(vin: string, status: string, country: string): Observable<Blob> {
    const url = `${BASE_URL}/recalls/certificate/${vin}?status=${status}&country=${country}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
